export enum RequestStatus {
  ALL = '',
  PENDING = 'pending',
  PROVISIONING = 'provisioning',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

export enum OnboardingType {
  ALL = '',
  USER_ONBOARDING_ADD = 'user_onboarding_add',
  USER_ONBOARDING_REMOVE = 'user_onboarding_remove',
  POD_ONBOARDING = 'pod_onboarding',
  CLOUD_REQUEST = 'cloud_request'
}

export const STATUS_LABELS: Record<RequestStatus, string> = {
  [RequestStatus.ALL]: 'All Statuses',
  [RequestStatus.PENDING]: 'Pending',
  [RequestStatus.PROVISIONING]: 'In Progress',
  [RequestStatus.COMPLETED]: 'Completed',
  [RequestStatus.FAILED]: 'Failed'
};

export const ONBOARDING_TYPE_LABELS: Record<OnboardingType, string> = {
  [OnboardingType.ALL]: 'All Types',
  [OnboardingType.USER_ONBOARDING_ADD]: 'User Onboarding - Add',
  [OnboardingType.USER_ONBOARDING_REMOVE]: 'User Onboarding - Remove',
  [OnboardingType.POD_ONBOARDING]: 'Pod Onboarding',
  [OnboardingType.CLOUD_REQUEST]: 'Cloud Request'
};

export const STATUS_OPTIONS = Object.values(RequestStatus).map(status => ({
  value: status,
  label: STATUS_LABELS[status]
}));

export const ONBOARDING_TYPE_OPTIONS = Object.values(OnboardingType).map(type => ({
  value: type,
  label: ONBOARDING_TYPE_LABELS[type]
}));

export enum TableColumn {
  SERIAL_NUMBER = 'S No.',
  REQUEST_NUMBER = 'Request Number',
  RAISED_BY = 'Raised By',
  RAISED_FOR = 'Raised For',
  DESCRIPTION = 'Description',
  REQUESTED_AT = 'Requested At',
  ONBOARDING_TYPE = 'Onboarding Type',
  STATUS = 'Status'
}

export enum SortableColumn {
  CREATED_AT = 'created_at',
  STATUS = 'status'
}
